// Third party
import * as React from 'react';
import { parseCookies, setCookie } from 'nookies';

// Utils
import { routes } from '@routes';

// UI
import { Button } from '@components/button';
import { Typography } from '@components/typography';
import { Link } from '@components/link';

const ACCEPTS_COOKIES_KEY = '__savvy_accepts_cookies__';

function isAcceptingCookies(): boolean {
  const cookies = parseCookies();

  return cookies[ACCEPTS_COOKIES_KEY] === 'true';
}

function acceptCookies(): void {
  setCookie(null, ACCEPTS_COOKIES_KEY, 'true', {
    maxAge: 90 * 24 * 60 * 60,
    path: '/',
  });
}

type Props = {};

export const AcceptCookieFooter: React.FC<Props> = ({}) => {
  const [_mounted, _setIsMounted] = React.useState<boolean>(false);
  const [hasAcceptedCookie, setAcceptedCookie] = React.useState<boolean>(false);

  React.useEffect(() => {
    _setIsMounted(true);
    if (isAcceptingCookies()) {
      setAcceptedCookie(true);
    }
  }, []);

  const handleClick = (): void => {
    acceptCookies();
    setAcceptedCookie(true);
  };

  if (!_mounted) return null;

  return hasAcceptedCookie ? null : (
    <div
      className={
        'fixed bottom-4 sm:bottom-6 left-1/2 -translate-x-1/2 px-8 py-4 w-11/12 sm:w-auto max-w-md bg-white rounded-lg shadow-xl z-50'

      }
    >
      <Typography
        variant="subtitle2"
        variantM="subtitle1"
        component="p"
        className="text-center text-gray-main"
      >
        By navigating this site, you consent to our use of cookies.
      </Typography>

      <div className="flex flex-row justify-between mt-4 items-center">
        <div className="w-1/2 flex justify-center">
          <Link to={routes.privacy} className="py-2">
            <Typography
              variant="subtitle2"
              component="p"
              className="text-primary-main"
            >
              Learn More
            </Typography>
          </Link>
        </div>

        <div className="w-1/3 flex justify-center">
          <Typography
            variant="subtitle2"
            component="p"
            className="text-gray-light"
          >
            |
          </Typography>
        </div>
        <div className="flex justify-center w-1/2">
          <Button
            variant="text"
            onClick={handleClick}
            data-testid="accept-cookies-button"
          >
            <Typography
              variant="subtitle2"
              component="p"
              className="text-primary-main "
            >
              I Agree
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  );
};
